import { Button } from 'antd'
import PropTypes from 'prop-types'

import { Link } from 'react-router-dom'

export default function LinkButton({ to, text = undefined, icon = undefined }) {
  return (
    <Link to={to}>
      <Button icon={icon} size="large" type="link">
        {text}
      </Button>
    </Link>
  )
}

LinkButton.propTypes = {
  to: PropTypes.string.isRequired,
  text: PropTypes.string,
  icon: PropTypes.node,
}
